define('view/block/progress.modal.view',['require','exports','module','underscore','uikit/uikit','fukit','fukit','fukit'],function(require, exports, module) {
  //prettier-ignore
  var _                  = require('underscore'),
      UIKit              = require('uikit/uikit'),
      NamedStateBehavior = require('fukit').NamedStateBehavior,
      GridContainerView  = require('fukit').GridContainerView,
      ExtendUtil         = require('fukit').ExtendUtil;

  var ProgressState = NamedStateBehavior.NamedState.extend({
    defaults: {
      canPause: true,
      canResume: false,
      canCancel: true,
    },

    initialize: function() {
      NamedStateBehavior.NamedState.prototype.initialize.apply(this, arguments);

      this.set('canPause', this.hasProgressControleMethod('pause'));
      this.set('canCancel', this.hasProgressControleMethod('cancel'));
    },

    setProgress: function(totalCompleted, totalToComplete) {
      return this.set('percent', (totalCompleted / totalToComplete) * 100);
    },

    setCurrentItemText: function(text) {
      return this.set('currentItemText', text);
    },

    clearState: function() {
      return this.set('state', '');
    },

    setCompleted: function() {
      return this.set('state', 'success');
    },

    setFailed: function() {
      return this.set('state', 'error');
    },

    pause: function() {
      this.set('canPause', false);
      this.set('canResume', true);
      this.invokeProgressControlMethod('pause');
      return this;
    },

    resume: function() {
      this.set('canPause', true);
      this.set('canResume', false);
      this.invokeProgressControlMethod('resume');
      return this;
    },

    cancel: function() {
      this.invokeProgressControlMethod('cancel');
      return this;
    },

    hasProgressControleMethod: function(methodName) {
      var progressControlInterface = this.getOption('progressControlInterface');
      if (progressControlInterface && _.isFunction(progressControlInterface[methodName])) {
        return true;
      } else {
        return false;
      }
    },

    invokeProgressControlMethod: function(methodName) {
      var args = _.rest(arguments);
      if (this.hasProgressControleMethod(methodName)) {
        var progressControlInterface = this.getOption('progressControlInterface');
        return progressControlInterface[methodName].apply(this, args);
      }
    },
  });

  var ProgressDimmerView = UIKit.Dimmer2.extend({
    options: _.extend({}, UIKit.Dimmer2.prototype.options, {
      page: true,
      // implement this interface to allow the progress view
      // to controls things
      // progressControlInterface: {
      //   # pause the uploads
      //   pause: function() {},
      //   # resume the uploads
      //   resume: function() {},
      //   # cancel the uploads
      //   cancel: function() {}
      // }
    }),

    behaviors: {
      NamedStateBehavior: {
        states: {
          main: function() {
            return {
              progressControlInterface: this.view.getOption('progressControlInterface'),
              modelClass: ProgressState,
            };
          },
        },
        behaviorClass: NamedStateBehavior,
      },
    },

    content: function() {
      var mainState = this.getState('main');
      return {
        content: {
          type: GridContainerView,
          attributes: {
            style: 'margin: 0 10em; font-size: 1em;',
          },
          components: [
            {
              type: GridContainerView.RowView,
              components: [
                {
                  content: {
                    type: UIKit.Progress,
                    active: true,
                    inverted: true,
                    model: mainState,
                    bindings: {
                      percent: 'percent',
                      text: 'currentItemText',
                      state: 'state',
                    },
                  },
                },
              ],
            },
            {
              type: GridContainerView.RowView,
              aligned: 'right',
              components: [
                {
                  content: {
                    type: UIKit.ComponentsContainerView,
                    components: [
                      {
                        type: UIKit.Button,
                        model: mainState,
                        attributes: {
                          style: 'margin-right: 1em;',
                        },
                        text: 'Resume',
                        color: 'green',
                        icon: 'play',
                        bindings: {
                          visible: 'canResume',
                        },
                        onPress: function() {
                          mainState.resume();
                        },
                      },
                      {
                        type: UIKit.Button,
                        model: mainState,
                        attributes: {
                          style: 'margin-right: 1em;',
                        },
                        text: 'Pause',
                        color: 'blue',
                        icon: 'pause',
                        bindings: {
                          visible: 'canPause',
                        },
                        onPress: function() {
                          mainState.pause();
                        },
                      },
                      {
                        type: UIKit.Button,
                        text: 'Cancel',
                        color: 'red',
                        bindings: {
                          visible: 'canCancel',
                        },
                        onPress: function() {
                          mainState.cancel();
                        },
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
      };
    },
  });

  module.exports = ProgressDimmerView;
});

